<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span>For Tessa<br/>With All the Bear’s Love<br/>Te quiero mucho, baby!</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?2c5b214f